
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlO as ObiOwnShipControlOElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-o.js';
 
 
 

 
 export const ObiOwnShipControlO = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-o',
   elementClass: ObiOwnShipControlOElement,
   events: {
     
   }
  });
 
 